import { render } from "./PaginationSizes.vue?vue&type=template&id=5e755180&scoped=true"
import script from "./PaginationSizes.vue?vue&type=script&lang=js"
export * from "./PaginationSizes.vue?vue&type=script&lang=js"

import "./PaginationSizes.vue?vue&type=style&index=0&id=5e755180&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e755180"]])

export default __exports__